import useSWR from "swr";
import {
  HeyLightConfigDTO,
  StripeConfigDTO,
} from "../../NormasTeachingCheckout/PaymentMethodConfiguration.ts";
import { createProductServiceAxiosClient } from "../createProductServiceAxiosClient.ts";
import { MoneyDTO } from "../NormasTeachingProduct/useNormasTeachingProductById.ts";

export type BundleProduct = {
  products: { id: string; priceInCents: MoneyDTO }[];
};

export type NormasTeachingBundleDTO = {
  _id: string;
  priceInCents: MoneyDTO;
  bundleName: string;
  variantBundleName: string;
  bundleDescription?: string;
  bundleProducts: BundleProduct[];
  stripeConfig?: StripeConfigDTO;
  heylightConfig?: HeyLightConfigDTO;
  purchaseAcTags: string[];
  refundAcTags: string[];
  analyticsTag?: string;
  isCouponEnabled?: boolean;
  /** Absent on bundles created before the flag existed, which are enabled. */
  isEnabled?: boolean;
};

export function useNormasTeachingBundleById(bundleId: string) {
  const { data, isLoading } = useSWR(`/bundles/${bundleId}`, async (url) => {
    const { data } =
      await createProductServiceAxiosClient().get<NormasTeachingBundleDTO>(url);
    return data;
  });

  return {
    bundle: data,
    isLoading,
  };
}
